import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, retry } from 'rxjs';
import { IAuthData, LoginModel } from '../models/loginViewModel';
import { Router, RouterStateSnapshot } from '@angular/router';
import { ROLE, Store } from '../constants/generic-enums';
import { decrypt, encrypt } from '../utils/crypto-util';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public num = 0;

  constructor(private http: HttpClient, private router: Router) {}

  login(body: LoginModel) {
    return this.http.post<any>(`${environment.apiUrl}/auth/login`, body).pipe(
      retry(this.num),
      map((response) => {
        return response;
      })
    );
  }

  public setUser(user: IAuthData) {
    const encryptedUser = encrypt(JSON.stringify(user), Store.USERSECRETKEY);
    localStorage.setItem('user', encryptedUser);
  }

  get currentUser(): IAuthData {
    const userDetails = localStorage.getItem('user')!;
    const decryptedUser = decrypt(userDetails, Store.USERSECRETKEY);
    return JSON.parse(decryptedUser) as IAuthData;
  }

  get isDevTeamOrAdmin() {
    return (
      this.isRootAdmin ||
      this.isICT ||
      this.isSupperAdmin ||
      this.isDSPRD
    );
  }

  get isICT() {
    return (
      this.currentUser.role_name.toLowerCase().trim() ===
      ROLE.ICT.toLowerCase().trim()
    );
  }

  get isSupperAdmin() {
    return (
      this.currentUser.role_name.toLowerCase().trim() ===
      ROLE.SuperAdmin.toLowerCase().trim()
    );
  }

  get isRootAdmin() {
    return (
      this.currentUser.role_name.toLowerCase().trim() ===
      ROLE.RootAdmin.toLowerCase().trim()
    );
  }

  get isBudgetDeskOfficer() {
    return (
      this.currentUser.role_name.toLowerCase().trim() ===
        ROLE.BudgetDeskOfficer.toLowerCase().trim() ||
      this.currentUser.role_name.toLowerCase().trim() ===
        ROLE.BudgetOfficer.toLowerCase().trim()
    );
  }

  get isBudgetOfficer() {
    return (
      this.currentUser.role_name.toLowerCase().trim() ===
      ROLE.BudgetOfficer.toLowerCase().trim()
    );
  }

  get isSPRD() {
    return (
      this.currentUser?.departmentName?.toLowerCase().trim() ===
      'Strategic Planning and Research Department'.toLowerCase().trim()
    );
  }

  get isBudgetDivision() {
    return (
      this.currentUser?.departmentName?.toLowerCase().trim() ===
      'BUDGET DIVISION'.toLowerCase().trim()
    );
  }

  get is_HR_Dept() {
    return (
      this.currentUser?.departmentName?.toLowerCase().trim() ===
      'HUMAN RESOURCES MANAGEMENT'.toLowerCase().trim()
    );
  }

  get is_FIANANCE_Dept() {
    return (
      this.currentUser?.departmentName?.toLowerCase().trim() ===
      'Finance and Accounts'.toLowerCase().trim()
    );
  }

  get is_ES_Dept() {
    return (
      this.currentUser?.departmentName?.toLowerCase().trim() ===
      'Executive Secretary and CEO’s Office'.toLowerCase().trim()
    );
  }

  get is_ZonalCoordinating_Office() {
    return (
      this.currentUser?.departmentName?.toLowerCase().includes(
        'Coordinating Office'.toLowerCase().trim()
      )
    );
  }

  get isHOD() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.HOD.toLowerCase().trim()
    );
  }

  get isHR() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.HR.toLowerCase().trim()
    );
  }

  get isDSPRD() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.DSPR.toLowerCase().trim()

    //   this.currentUser?.role_name?.toLowerCase().trim() ===
    //   ROLE.HOD.toLowerCase().trim() && this.isSPRD
    );
  }

  get isDFA() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.DFA.toLowerCase().trim() 

      //  this.currentUser?.role_name?.toLowerCase().trim() ===
      // ROLE.HOD.toLowerCase().trim() && this.is_FIANANCE_Dept
    );
  }

  get isES() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.ES.toLowerCase().trim() 

      // this.currentUser?.role_name?.toLowerCase().trim() ===
      // ROLE.HOD.toLowerCase().trim() && this.is_ES_Dept
    );
  }

  get isZonalCoordinator() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.ZonalCoordinator.toLowerCase().trim()
      
      //  this.currentUser?.role_name?.toLowerCase().trim() ===
      // ROLE.HOD.toLowerCase().trim() && this.is_ZonalCoordinating_Office
    );
  }

  get isHead_Of_Budget() {
    return (
      this.currentUser?.role_name?.toLowerCase().trim() ===
      ROLE.Head_Of_Budget.toLowerCase().trim()
    );
  }

  get isFinance_Treasury() {
    return (
      ROLE.Finance_Treasury.toLowerCase() ===
        this.currentUser.role_name.toLowerCase()
    );
  }

  get isAuditor() {
    return (
      ROLE.Auditor.toLowerCase() ===
        this.currentUser.role_name.toLowerCase()
    );
  }

  routeGuardNavigation(state: RouterStateSnapshot) {
    this.router.navigate(['/' + 'login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  public isTokenExpired(): boolean {
    const token = this.currentUser.token;
    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(token);
    return isExpired;
  }

  logOut() {
    localStorage.removeItem('user');
    this.router.navigate(['/' + 'login']);
  }

  changePassword(body: any) {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/change-password`, body)
      .pipe(
        retry(this.num),
        map((response) => {
          return response;
        })
      );
  }

  resetPassword(body: any) {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/reset-password`, body)
      .pipe(
        retry(this.num),
        map((response) => {
          return response;
        })
      );
  }

  forgotPassword(body: any) {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/forgot-password`, body)
      .pipe(
        retry(this.num),
        map((response) => {
          return response;
        })
      );
  }
}
